let Obj = {
    el: null,
    startLoading: () => {},
    stopLoading: () => {}
}

export default function loadingButton(btn) {
    let obj = Object.create(Obj)

    obj.el = btn

    if (!obj.el) {
        obj.el = document.createElement('button')
    }

    obj.el.insertAdjacentHTML('beforeend', getSvgMarkup())

    obj.startLoading = startLoading.bind(obj)
    obj.stopLoading = stopLoading.bind(obj)

    return obj
}

function getSvgMarkup() {
    return `<svg class="u-btn__loading-icon js-loading-icon">
        <use xlink:href="/application/themes/the_escape/assets/images/svgicons.svg#oval"></use>
    </svg>`
}

function startLoading() {
    this.el.classList.add('is-loading')
}

function stopLoading() {
    this.el.classList.remove('is-loading')
}
